import core, { App } from '@gin-betting/core';

import {
    ADD_MATCH_ID,
    ADD_NEAREST_MATCH_ID,
    CHANGE_VIEWER_MODE,
    CLEAR_MATCH_IDS,
    CLOSE_FULLSCREEN_STREAM,
    DELETE_MATCH_ID,
    OPEN_FULLSCREEN_STREAM,
    PIN_STREAM,
    REMOVE_LAST_PLAYED_STREAM_MATCH_ID,
    RESET_VIEWER_MODE,
    SET_LAST_PLAYED_STREAM_MATCH_ID,
    SET_LOAD_STATUS,
    UNPIN_STREAM,
    ViewerMode,
} from './constants';
import { SetLoadScriptStatus } from './types';

const {
    utils: { makeAction },
} = core;

export const openFullScreenStream = (payload: { matchId: string }) =>
    makeAction(OPEN_FULLSCREEN_STREAM, payload);

export const closeFullScreenStream = () => makeAction(CLOSE_FULLSCREEN_STREAM);

export const pinStream = (matchId: string) =>
    makeAction(PIN_STREAM, { matchId });

export const unpinStream = () => makeAction(UNPIN_STREAM);

export const toggleStreamFullscreen = ({
    matchId,
}: {
    matchId: string | null;
}) => (matchId ? openFullScreenStream({ matchId }) : closeFullScreenStream());

// export const toggleUserPinned = ({
//     matchId,
// }: {
//     isUserPinnedStream: boolean;
// }) => (isUserPinnedStream ? userPinStream() : userUnpinStream());

export const addMatchId = (payload: {
    matchId: string;
    withClearPrev?: true;
}) => makeAction(ADD_MATCH_ID, payload);

export const clearMatchIds = () => makeAction(CLEAR_MATCH_IDS);

export const deleteMatchId = (payload: { matchId: string }) =>
    makeAction(DELETE_MATCH_ID, payload);

export const addNearestMatchId = (payload: { matchIds: string[] }) =>
    makeAction(ADD_NEAREST_MATCH_ID, payload);

export const setLastPlayedStreamMatchId = (payload: { matchId: string }) =>
    makeAction(SET_LAST_PLAYED_STREAM_MATCH_ID, payload);

export const removeLastPlayedStreamMatchId = () =>
    makeAction(REMOVE_LAST_PLAYED_STREAM_MATCH_ID);

export const setLoadScriptStatus = (payload: SetLoadScriptStatus) =>
    makeAction(SET_LOAD_STATUS, payload);

export const changeViewerMode = (viewerMode: ViewerMode) =>
    makeAction(CHANGE_VIEWER_MODE, {
        viewerMode,
    });

export const resetViewerMode = () =>
    makeAction(RESET_VIEWER_MODE, {
        viewerMode: ViewerMode.NONE,
    });

export const Actions = {
    addMatchId,
    deleteMatchId,
    openFullScreenStream,
    closeFullScreenStream,
    pinStream,
    unpinStream,
    setLastPlayedStreamMatchId,
    removeLastPlayedStreamMatchId,
    addNearestMatchId,
    clearMatchIds,
    setLoadScriptStatus,
    changeViewerMode,
    resetViewerMode,
};

export type Actions = App.ActionsUnion<typeof Actions>;
